import { IScheduleFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import FormCreator from '../../../pageForm/FormCreator';
import React from 'react';
import BadgeRound from '../../../../components/BadgeRound';
import KubitTooltip from '../../../../components/KubitTooltip';

interface IProps {
  recipients: IScheduleFieldsFragment['recipients'];
  emailList: IScheduleFieldsFragment['emailList'];
}

interface IRecipientsByEmailProps {
  email: string;
  recipients: IScheduleFieldsFragment['recipients'];
}

const RecipientByEmail = ({ email, recipients }: IRecipientsByEmailProps) => {
  const recipient = recipients.find((recipient) => recipient?.email === email);
  if (recipient) {
    return <FormCreator label={recipient.email} picture={recipient.picture} />;
  }

  return <FormCreator label={email} />;
};

// By design, should render max 2 elements
const EmailRecipients = ({ recipients, emailList }: IProps) => {
  // if more than 2 - show first recipient and a badge with amount of others
  if (emailList.length > 2) {
    const firstEmail = emailList[0];
    const otherEmails = emailList.slice(1);

    return (
      <>
        <RecipientByEmail email={firstEmail} recipients={recipients} />
        <KubitTooltip
          content={otherEmails.join(', ')}
          placement="bottom"
          noOpenDelay={true}
        >
          <BadgeRound size="regular">
            {otherEmails.length > 9 ? '9+' : otherEmails.length}
          </BadgeRound>
        </KubitTooltip>
      </>
    );
  }

  return (
    <>
      {emailList.map((email) => (
        <RecipientByEmail key={email} email={email} recipients={recipients} />
      ))}
    </>
  );
};

export default EmailRecipients;
